<template>
    <div>
        <el-divider></el-divider>
        <el-col :span="15">
            {{ $t("lang.选择日期") }}<el-date-picker style="margin-left: 20px;" v-model="searchObj.searchRange" @change="getList" type="datetimerange" :picker-options="pickerOptions" :range-separator="$t('lang.至')" :start-placeholder="$t('lang.开始日期')" :end-placeholder="$t('lang.结束日期')" align="right">
            </el-date-picker>
            <el-button type="primary" @click="uploadRow" style="margin-left: 20px;" icon="vxe-icon-arrows-up">{{ $t("lang.上传") }}</el-button>
            <el-button type="success" @click="addRow" style="margin-left: 20px;" icon="vxe-icon-add">{{ $t("lang.增加") }}</el-button>
            <el-button type="info" @click="getList" style="margin-left: 20px;" icon="vxe-icon-refresh">{{ $t("lang.刷新") }}</el-button>
            <vxe-table class="mytable-style" ref="myTable" :loading="tableLoading" :data="tableData" style="margin-top: 5px;" border :row-config="{ isCurrent: true, isHover: true }" :checkbox-config="{ labelField: 'cho' }" @current-row-change="currentRowChange" height="630" :header-cell-class-name="headerCellClassName" :cell-class-name="cellClassName">
                <vxe-column type="checkbox" width="40"></vxe-column>
                <vxe-column field="serialNumber" :title="$t('lang.序列号')" width="120"></vxe-column>
                <vxe-column field="shiYanBianHao" :title="$t('lang.试验编号')" align="right"></vxe-column>
                <vxe-column field="shiYanShiJian" :title="$t('lang.试验时间')" width="150"></vxe-column>
                <vxe-column field="wenDu1" :title="$t('lang.小球') + '1' + $t('lang.温度')" width="90" :formatter="({ cellValue }) => { return cellValue + '℃' }" align="right"></vxe-column>
                <vxe-column field="time1" :title="$t('lang.小球') + '1' + $t('lang.时间')" align="center" width="90"></vxe-column>
                <vxe-column field="wenDu2" :title="$t('lang.小球') + '2' + $t('lang.温度')" width="90" :formatter="({ cellValue }) => { return cellValue + '℃' }" align="right"></vxe-column>
                <vxe-column field="time2" :title="$t('lang.小球') + '2' + $t('lang.时间')" align="center" width="90"></vxe-column>
                <vxe-column field="version" :title="$t('lang.版本')" align="center" width="90"></vxe-column>
                <vxe-column :title="$t('lang.操作')" width="100" align="center">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="success" icon="vxe-icon-edit" circle @click="editRow(row)"></vxe-button>
                        <vxe-button mode="text" status="primary" icon="vxe-icon-delete" circle @click="delRow(row)"></vxe-button>
                    </template>
                </vxe-column>

            </vxe-table>
            <vxe-pager align="left" @page-change="getList" :page-size.sync="searchObj.pageSize" :current-page.sync="searchObj.currentPage" :total="searchObj.total" :layouts="['PrevPage', 'Jump', 'PageCount', 'NextPage', 'Total']">
            </vxe-pager></el-col>
        <el-col :span="9" style="padding-left: 5px;">
            <div id="div_rhd200_chart"></div>
            <div class="rhd200-screenshots" style="margin-top: 10px; display: flex; gap: 10px;">
                <div class="rhd200-screenshot-item">
                    <div class="rhd200-screenshot-title">{{ $t('lang.小球') + "1" }}</div>
                    <el-image v-if="screenshot1Src" :src="screenshot1Src" fit="contain" style="width: 100%; height: 180px;"></el-image>
                    <div v-else class="rhd200-no-image">{{ $t('lang.无图片') }}</div>
                </div>
                <div class="rhd200-screenshot-item">
                    <div class="rhd200-screenshot-title">{{ $t('lang.小球') + "2" }}</div>
                    <el-image v-if="screenshot2Src" :src="screenshot2Src" fit="contain" style="width: 100%; height: 180px;"></el-image>
                    <div v-else class="rhd200-no-image">{{ $t('lang.无图片') }}</div>
                </div>
            </div>
            <vxe-table :data="chartDataForTable" style="margin-top: 5px;" border height="300">
                <vxe-column field="fenZhong" :title="$t('lang.分钟') + '(min)'" align="right"></vxe-column>
                <vxe-column field="wenDu" :title="$t('lang.温度') + '(℃)'" align="right"></vxe-column>
            </vxe-table>
        </el-col>
        <!-- 编辑对话框 -->
        <el-dialog :title="$t('lang.编辑记录')" :visible.sync="editDialogVisible" width="600px">
            <el-form ref="editFormRef" :model="editForm" :rules="editFormRules" label-width="120px">
                <el-form-item :label="$t('lang.序列号')">
                    <el-input v-model="editForm.serialNumber" :readonly="!isAddMode" :placeholder="$t('lang.请输入序列号')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.试验编号')">
                    <el-input v-model="editForm.shiYanBianHao" :readonly="!isAddMode" :placeholder="$t('lang.请输入试验编号')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.试验时间')">
                    <el-date-picker v-model="editForm.shiYanShiJian" type="datetime" :placeholder="$t('lang.请选择试验时间')"></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('lang.小球') + '1' + $t('lang.温度')">
                    <el-input-number v-model="editForm.wenDu1" :precision="2" :min="0" :placeholder="$t('lang.请输入温度')"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('lang.小球') + '1' + $t('lang.时间')">
                    <el-input v-model="editForm.time1" :placeholder="$t('lang.请输入时间')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.小球') + '2' + $t('lang.温度')">
                    <el-input-number v-model="editForm.wenDu2" :precision="2" :min="0" :placeholder="$t('lang.请输入温度')"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('lang.小球') + '2' + $t('lang.时间')">
                    <el-input v-model="editForm.time2" :placeholder="$t('lang.请输入时间')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.每分钟数据')" class="mei-fenzhong-item">
                    <el-input type="textarea" v-model="editForm.meiFenZhong" :placeholder="$t('lang.请输入每分钟数据, 以逗号分隔')"></el-input>
                    <div class="form-tip">{{ $t('lang.必须输入数字以逗号隔开') }}</div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">{{ $t('lang.取消') }}</el-button>
                <el-button type="primary" @click="saveEdit">{{ $t('lang.保存') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";
import HighCharts from "highcharts";
import dark from "highcharts/themes/dark-unica";
import exportHighChart from "highcharts/modules/exporting";
import exportOffHighChart from "highcharts/modules/offline-exporting";
exportHighChart(HighCharts);
exportOffHighChart(HighCharts);
dark(HighCharts);
import Vue from 'vue';
import { Grid, GridItem } from 'vant';
Vue.use(Grid);
Vue.use(GridItem);
export default {
    components: {

    },
    data() {
        let that = this;
        return {
            activeName: 0,
            tableLoading: false,
            tableData: [],
            searchRange: null,
            searchObj: {
                currentPage: 1,
                pageSize: 50,
                total: 0,
                searchRange: null,
            },
            detailData: {},
            chartData: [],
            editDialogVisible: false,
            isAddMode: false,
            editForm: {},
            editFormRules: {
                serialNumber: [
                    { required: true, message: that.$t('lang.请输入序列号'), trigger: 'blur' }
                ],
                shiYanBianHao: [
                    { required: true, message: that.$t('lang.请输入试验编号'), trigger: 'blur' }
                ],
                meiFenZhong: [
                    { required: true, message: that.$t('lang.必须输入数字以逗号隔开'), trigger: 'blur' },
                    {
                        validator: function (rule, value, callback) {
                            if (!value || !/^\s*(\d+(?:\.\d+)?)(\s*,\s*\d+(?:\.\d+)?)*\s*$/.test(value)) {
                                callback(new Error(that.$t('lang.必须输入数字以逗号隔开')));
                            } else {
                                callback();
                            }
                        }, trigger: ['blur', 'change']
                    }
                ]
            },
            // searchRange: [moment().startOf("day").add(-30, "days").toDate(), moment().startOf("day").add(1, "days").toDate()],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "1" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "2" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-1, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "3" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-2, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "7" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-6, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "15" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-14, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                    {
                        text: "30" + that.$t("lang.天"),
                        onClick(picker) {
                            picker.$emit("pick", [moment().startOf("day").add(-29, "days").toDate(), moment().startOf("day").add(1, "days").toDate()]);
                        },
                    },
                ],
            },
        };
    },
    computed: {
        chartDataForTable() {
            let that = this;
            return that.chartData.map((item, index) => {
                return { fenZhong: index, wenDu: item };
            });
        },
        screenshot1Src() {
            let value = this.detailData.screenshot1;
            if (!value && this.$refs.myTable && this.$refs.myTable.currentRow) {
                value = this.$refs.myTable.currentRow.screenshot1;
            }
            return this.getBase64Src(value);
        },
        screenshot2Src() {
            let value = this.detailData.screenshot2;
            if (!value && this.$refs.myTable && this.$refs.myTable.currentRow) {
                value = this.$refs.myTable.currentRow.screenshot2;
            }
            return this.getBase64Src(value);
        }
    },
    methods: {
        getBase64Src(value) {
            if (!value) {
                return "";
            }
            if (typeof value === 'string' && value.startsWith("data:")) {
                return value;
            }
            return "data:image/png;base64," + value;
        },
        uploadRow() {
            let that = this;
            that.$confirm(that.$t("lang.确定要上传吗")).then(function () {
                const $table = that.$refs.myTable;
                const selectRecords = $table.getCheckboxRecords();
                if (selectRecords.length == 0) {
                    that.$message({
                        type: "warning",
                        message: that.$t("lang.请至少选择一条数据"),
                    });
                    return;
                }
            });
        },
        addRow() {
            let that = this;
            that.isAddMode = true;
            that.editForm = {
                serialNumber: "",
                shiYanBianHao: "",
                shiYanShiJian: moment().format("YYYY-MM-DD HH:mm:ss"),
                wenDu1: 0,
                time1: "",
                wenDu2: 0,
                time2: "",
                meiFenZhong: "",
            };
            that.editDialogVisible = true;
        },
        editRow(row) {
            let that = this;
            that.isAddMode = false;
            that.editForm = { ...row };
            that.editDialogVisible = true;
        },
        saveEdit() {
            let that = this;
            that.$refs.editFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }
                let url = that.isAddMode ? "RHD200_Result/AddModel" : "RHD200_Result/UpdateModel";
                that.axios.post(url, that.editForm).then(function (response) {
                    if (response.data.code == 101) {
                        that.$message({
                            type: "success",
                            message: that.$t("lang.保存成功"),
                        });
                        that.editDialogVisible = false;
                        that.getList();
                    } else {
                        that.$message({
                            type: "error",
                            message: response.data.msg || that.$t("lang.保存失败"),
                        });
                    }
                }).catch(function () {
                    that.$message({
                        type: "error",
                        message: that.$t("lang.保存失败"),
                    });
                });
            });
        },
        delRow(row) {
            let that = this;
            that.$confirm(that.$t("lang.确定要删除吗")).then(function () {
                that.axios
                    .post("RHD200_Result/DelModel", {
                        id: row.id,
                    })
                    .then(function (response) {
                        if (response.data.code == 101) {
                            that.$message({
                                type: "success",
                                message: that.$t("lang.删除成功"),
                            });
                            that.getList();
                        }
                    });
            });
        },
        currentRowChange({ newValue }) {
            let that = this;
            const loading = that.$loading({
                lock: true,
                text: that.$t("lang.加载中"),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            that.axios.post("RHD200_Result/GetDetail", { id: newValue.id }).then((response) => {
                loading.close();
                that.detailData = response.data.data;
                that.loadChart();
            });
        },
        getList() {
            let that = this;
            that.tableLoading = true;
            that.axios.post("RHD200_Result/GetList", that.searchObj).then((response) => {
                that.tableLoading = false;
                that.tableData = response.data.data.data;
                that.searchObj.total = response.data.data.total;
            });
        },
        headerCellClassName: function ({ column }) {
            if (column.field == 'wenDu1' || column.field == 'time1' || column.field == 'wenDu2' || column.field == 'time2') {
                return 'rhd200-result-col-warning';
            }
            return null;
        },
        cellClassName: function ({ column }) {
            if (column.field == 'wenDu1' || column.field == 'time1' || column.field == 'wenDu2' || column.field == 'time2') {
                return 'rhd200-result-col-warning';
            }
            return null;
        },
        loadChart() {
            let that = this;
            HighCharts.chart("div_rhd200_chart", {
                lang: {
                    viewFullscreen: that.$t("lang.全屏"),
                    printChart: that.$t("lang.打印图表"),
                    downloadJPEG: that.$t("lang.导出JPEG"),
                    downloadPDF: that.$t("lang.导出PDF"),
                    downloadPNG: that.$t("lang.导出PNG"),
                    downloadSVG: that.$t("lang.导出SVG"),
                },
                tooltip: {
                    formatter: function () {
                        return that.$t("lang.温度") + "(℃)：" + this.y + "<br />" + that.$t("lang.分钟") + "(min)：" + this.x;
                    },
                },
                title: { text: that.$t("lang.温度曲线图") },
                credits: { enabled: false },
                //global: { useUTC: false },这里要在开头的时候初始化，而不是这里。
                yAxis: { title: { text: that.$t("lang.温度") } },
                series: [{
                    name: that.$t("lang.温度") + "/" + that.$t("lang.分钟"),
                    data: that.chartData = JSON.parse("[" + that.detailData.meiFenZhong + "]")
                }],
                exporting: {
                    fallbackToExportServer: false,
                },
            });


        }
    },

    mounted() {
        let that = this;
        that.getList();
    }

};
</script>

<style>
.rhd200-result-col-warning {
    color: #F56C6C;
}

.rhd200-screenshots {
    display: flex;
    gap: 10px;
}

.rhd200-screenshot-item {
    flex: 1;
    min-width: 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px;
    background: #fff;
}

.rhd200-screenshot-title {
    margin-bottom: 6px;
    font-weight: 600;
}

.rhd200-no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 180px;
    color: #909399;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
}

.mei-fenzhong-item .form-tip {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
}
</style>